exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vertical-align-middle {\r\n  vertical-align: middle;\n}\n.k-table-actions .v-btn.k-header-btn span.filter-check-icon {\r\n  font-size: 11px;\r\n  position: absolute;\r\n  top: -16px;\r\n  right: -5px;\r\n  background: var(--sb-error, #dc2626);\r\n  color: white;\r\n  border-radius: 100%;\r\n  font-weight: bold;\r\n  height: 18px;\r\n  width: 18px;\r\n  line-height: 18px;\n}\r\n", ""]);

// exports
